<template>
    <div class="wrapper d-flex align-center justify-center">
        <div class="inner">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'card-container',
};
</script>
<style lang="scss" scoped>
.wrapper {
    position: relative;
    width: 300px;
    height: 300px;
    border-radius: 9px;
    overflow: visible;
    @include break('sm') {
        width: 500px;
    }
    @include break('md') {
        width: 380px;
        height: 562px;
        border-radius: 16px;
    }
    background-color: transparent;
    perspective: 1000px;
    .inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transform-style: preserve-3d;
    }
    // Add shadows back in later if we can get the animations working
    // box-shadow: 24px 24px 16px rgba(0, 0, 0, 0.3);
}
</style>
